import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";

const smallFont = {fontSize: 15};

export default function DataSourceSelect({dataSource, setDataSource, setAccountNumber, setBrokerage}) {
    return (
        <RadioGroup
            row
            aria-label="dataSource"
            name="dataSource"
            value={dataSource}
            onChange={(ev) => {
                setDataSource(ev.target.value);
                if (ev.target.value === "SIMULATED") {
                    setAccountNumber("BACKTEST");
                    setBrokerage("BACKTEST");
                }
            }}
        >
            <Grid container>
                <Grid item xs={3}>
                    <FormLabel><Typography style={smallFont}>dataSource:</Typography></FormLabel>
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel value="LIVE" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>LIVE</Typography>}/>
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel value="SIMULATED" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>SIMULATED</Typography>}/>
                </Grid>
            </Grid>
        </RadioGroup>
    );
}